import { commaingNumber } from '../../utils'

const raiseDisputeModalSchema = ({data = {}, value = '', error, changeHandler}) => {
  return(
    <tr className='text-gray-600 bg-gray-100'>
      <td className='py-3 px-6' style={{ width: '25%' }}>{data.service}</td>
      <td className='font-semibold py-3 px-6' style={{ width: '25%' }}>₹{commaingNumber(data.bill_amount)}</td>
      <td className='py-3 px-6' style={{ width: '50%' }}>
        <span className='font-semibold'>Reason for rejection</span><br />
        <textarea value={value} onChange={changeHandler} className='mt-2 h-20 w-full rounded-md border border-gray-200 resize-none focus:ring-0'/>
        <p className='mb-0 text-red-600'>{error}</p>
      </td>
    </tr>
  )
}

export default raiseDisputeModalSchema